import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { GroupContainer } from "../../../../common/components";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type AuthorComposerViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const AuthorComposerView: React.FC<AuthorComposerViewProps> = ({
  snapshotData,
}) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("AuthorComposer");
  const renderExtension = useSnapshotExtension("AuthorComposer");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <GroupContainer
        id="personalInformation"
        title={langStore.groupAuthorComposerPersonalInformationLabel}
      >
        <FormControl fullWidth>
          <ShowMultiLine
            label={langStore.AuthorComposerFirstNameLabel}
            value={String(snapshotData?.firstName ?? "")}
          />
          <ShowMultiLine
            label={langStore.AuthorComposerLastNameLabel}
            value={String(snapshotData?.lastName ?? "")}
          />
          <ShowMultiLine
            label={langStore.AuthorComposerTaxIdTypeLabel}
            value={String(snapshotData?.taxIdType ?? "")}
          />
          <ShowMultiLine
            label={langStore.AuthorComposerTaxIdLabel}
            value={String(snapshotData?.taxId ?? "")}
          />
        </FormControl>
      </GroupContainer>
      <GroupContainer
        id="professionalInformation"
        title={langStore.groupAuthorComposerProfessionalInformationLabel}
      >
        <FormControl fullWidth>
          <ShowMultiLine
            label={langStore.AuthorComposerIpiLabel}
            value={String(snapshotData?.ipi ?? "")}
          />
        </FormControl>
      </GroupContainer>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
